window.addEventListener("DOMContentLoaded", () => {
    const dealCards = document.querySelectorAll(".deal-card");
    const stickyCards = document.querySelectorAll(".sticky-deal");

    const adbButton = document.querySelector(".about-hero-adb").firstElementChild;
    const priceNodes = document.querySelectorAll(".custom-price .custom-price-amount");

    const stickyFooterPriceQuantity = document.querySelector(".sticky-brand-price .sticky-brand-price--quantity");
    const stickyFooterPriceAmount = document.querySelector(".sticky-brand-price .sticky-brand-price--amount");

    let currency;
    if (Shopify && Shopify.shop) {
      let currencyCode = Shopify.currency.active;
      if (currencyCode === "AUD") {
        currency = "A$";
      } else if (currencyCode === "CAD") {
        currency = "C$";
      } else currency = "$";
    }

    dealCards.forEach((el, index) => {
        const itemPrice = el.querySelector(".deal-price").dataset.fp;
        if (el.classList.contains("selected")) {
            const variant = el.dataset.variant;
            adbButton.setAttribute("data-variant", variant);
        }
        el.addEventListener("click", () => {

            document.querySelectorAll(".interest-free-payment").forEach(interestParent => {
              const interestElement = interestParent.querySelector("b");
              interestElement.innerText = `${currency}${itemPrice / 4}`;
              interestElement.setAttribute('data-variant', el.dataset.variant);
            });

            dealCards.forEach(el => el.classList.remove("selected"));
            stickyCards.forEach(el => el.classList.remove("sticky-selected"));
            el.classList.add("selected");

            if (index < 3) {
              dealCards[index].classList.add("selected");
              dealCards[index + 3].classList.add("selected");
              stickyCards[index].classList.add("sticky-selected");
            } else {
              dealCards[index].classList.add("selected");
              dealCards[index - 3].classList.add("selected");
              stickyCards[index - 3].classList.add("sticky-selected");
            }
            
            priceNodes.forEach(el => el.innerText = `${currency}${itemPrice}`);

            const selectedQuantity = Number(document.querySelector('.deal-card.selected').dataset.quantity);

            stickyFooterPriceQuantity.innerText = selectedQuantity;
            stickyFooterPriceAmount.innerText = `${currency}${itemPrice / selectedQuantity}`;
            stickyFooterPriceAmount.setAttribute("data-variant", variant);
            stickyFooterPriceAmount.setAttribute("data-price-multiplier", Math.round(1 / selectedQuantity * 100) / 100);
            // if (window.innerWidth < 770) {
            //   document.querySelector(".sticky-brand-price").innerText = `${selectedQuantity} x ${currency}${itemPrice / selectedQuantity}`;
            // }
            const variant = el.dataset.variant;
            adbButton.setAttribute("data-variant", variant);

            if (el.querySelector(".meta-badge") !== null) {
                el.classList.add("bv");
            } else el.classList.remove("bv");
        });
    });

    stickyCards.forEach((el, index) => {
      const itemPrice = el.querySelector(".sticky-deal-price").dataset.price;
      if (el.classList.contains("sticky-selected")) {
        const variant = el.dataset.variant;
        adbButton.setAttribute("data-variant", variant);
      }
      
      el.addEventListener("click", () => {
        document.querySelectorAll(".interest-free-payment").forEach(interestParent => {
          const interestElement = interestParent.querySelector("b");
          interestElement.innerText = `${currency}${itemPrice / 4}`;
          interestElement.setAttribute('data-variant', el.dataset.variant);
        });
        
        dealCards.forEach(el => el.classList.remove("selected"));
        stickyCards.forEach(el => el.classList.remove("sticky-selected"));
        el.classList.add("sticky-selected");
        dealCards[index].classList.add("selected");
        dealCards[index + 3].classList.add("selected");

        priceNodes.forEach(el => el.innerText = `${currency}${itemPrice}`);
        const variant = el.dataset.variant;
        adbButton.setAttribute("data-variant", variant);

        const selectedQuantity = Number(document.querySelector('.deal-card.selected').dataset.quantity);

        stickyFooterPriceQuantity.innerText = selectedQuantity;
        stickyFooterPriceAmount.innerText = `${currency}${itemPrice / selectedQuantity}`;
        stickyFooterPriceAmount.setAttribute("data-variant", variant);
        stickyFooterPriceAmount.setAttribute("data-price-multiplier", Math.round(1 / selectedQuantity * 100) / 100);
      });
    });
});

let callback = (entries, observer) => {
  entries.forEach(entry => {
    entry.target.style.backgroundColor = entry.isIntersecting ? 'green' : 'red';
    entry.target.innerHTML = entry.intersectionRatio;
  })
}
let observer = new IntersectionObserver(callback, {
  threshold: [0.5] // If 50% of the element is in the screen, we count it!
  // Can change the thresholds based on your needs. The default is 0 - it'll run only when the element first comes into view
});
  
  
  
['div1', 'div2', 'div3', 'div4'].forEach(d => {
  const div = document.getElementById(d);
  if (div) observer.observe(div);
})